import { render } from "./BackupEditApp.vue?vue&type=template&id=3314ff5c"
import script from "./BackupEditApp.vue?vue&type=script&lang=js"
export * from "./BackupEditApp.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__